import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { updateUser } from '../config/Actions';

export default function UserUpdate() {
    const {id} = useParams()
    const users = useSelector(state=>state.users)
    const navigate = useNavigate()
    const [user,setUser] = useState(users.find(item=>item.id == id))
    const dispatch = useDispatch()
    const handleChange = (e)=>{
        setUser({...user ,id:id , [e.target.name]:e.target.value})
    }
  return (
    <div>
    <form className='w-50 ms-5 bg-dark text-light p-5'>
            <div className='form-group'>
        <label className='form-label'>ID :</label>
       <input className='form-control' name='id' type='text' value={id}  disabled/>       
        </div>
        <div className='form-group'>
        <label className='form-label'>First Name :</label>
       <input className='form-control' name='firstName' type='text' value={user.firstName}  onChange={handleChange} />       
        </div>
        <div className='form-group'>
        <label className='form-label'>Last Name :</label>
       <input className='form-control' name='lastName' type='text' value={user.lastName} onChange={handleChange}  />       
        </div>
        <div className='form-group'>
        <label className='form-label'>Age :</label>
       <input className='form-control' name='age' type='text' value={user.age} onChange={handleChange}  />       
        </div>
        <div className='form-group w-100'>
            <button className='btn btn-primary mt-3 w-100' type='button' onClick={()=>{dispatch(updateUser(user));navigate('/')}}> Update </button>
        </div> 
    </form>
</div>
  )
}
